import Vue from 'vue'
import store from '../store/store'

Vue.mixin({
  methods: {
    $hasFeature (...features) {
      // if user didn't pass any permissions
      if (!features) {
        return false
      }

      // reserved keyword to show section to anybody
      if (features[0] === 'all') {
        return true
      }

      // get current account
      const activeAccount = store.getters['authentication/activeAccount']

      // check if there is any permissions at all
      // eslint-disable-next-line no-extra-boolean-cast
      if (!activeAccount.features) {
        return false
      }

      // loop over permissions array and check them all
      for (const feature of features) {
        // check if permission in current.permissions array
        if (activeAccount.features.indexOf(feature) === -1) {
          return false
        }
      }

      return true
    },
    $hasAnyFeature (...features) {
      if (Array.isArray(features[0])) {
        features = features[0]
      }

      // loop over features array and check them all
      for (const feature of features) {
        // check if features in current.features array
        if (this.$hasFeature(feature)) {
          return true
        }
      }

      return false
    },
    $can (...permissions) {
      // if user didn't pass any permissions
      if (!permissions) {
        return false
      }

      // reserved keyword to show section to anybody
      if (permissions[0] === 'all') {
        return true
      }

      // get current account
      const activeAccount = store.getters['authentication/activeAccount']

      // check if there is any permissions at all
      // eslint-disable-next-line no-extra-boolean-cast
      if (!activeAccount.permissions) {
        return false
      }

      // loop over permissions array and check them all
      for (const permission of permissions) {
        // check if permission in current.permissions array
        if (activeAccount.permissions.indexOf(permission) === -1) {
          return false
        }
      }

      return true
    },
    $canAny (...permissions) {
      if (Array.isArray(permissions[0])) {
        permissions = permissions[0]
      }

      // loop over permissions array and check them all
      for (const permission of permissions) {

        // check if permission in current.permissions array
        if (this.$can(permission)) {
          return true
        }
      }

      return false
    }
  }
})
